import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

type marketingPreferencesProps = {
  isLoadInNewTab: boolean;
  isSuccess: boolean;
  url?: string;
};

type cvtModalCloseProps = {
  label: string;
  url: string;
};

type cvtPreferencesProps = {
  value: boolean;
  vrm: string;
};

const categoryAccount = {
  category: 'account',
} as const;

export const ACCOUNTS_PAGE_EVENTS = {
  CVT_ALERTS_MODAL: (url: string = 'N/A') => {
    GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      ...categoryAccount,
      name: 'manage_cvt_preferences',
      url,
    });
    GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
      ...categoryAccount,
      name: 'cvt_preferences',
    });
  },
  CVT_ALERTS_MODAL_CLOSE: ({ label = 'N/A', url }: cvtModalCloseProps) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    ...categoryAccount,
    label,
    name: 'cvt_preferences_close',
    url,
  }),
  CVT_ALERTS_PREFERENCES: ({ value, vrm }: cvtPreferencesProps) => GENERIC_ANALYTICS_EVENTS.TOGGLE_CLICK_EVENT({
    ...categoryAccount,
    label: vrm,
    name: 'cvt_preferences',
    value,
  }),
  MARKETING_PREFERENCES: ({ isLoadInNewTab, isSuccess = false, url = 'N/A' }: marketingPreferencesProps) =>
    GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
      ...categoryAccount,
      button_label: 'Manage your email and SMS preferences',
      label: isLoadInNewTab ? 'new_tab' : 'same_tab',
      name: 'manage_marketing_preferences',
      success: isSuccess,
      url,
    }),
} as const;
